import { FilterList } from "@mui/icons-material";

import { SearchSettings } from "components/UI/SearchSettings/SearchSettings";

import styles from "./HeaderAdvancedFilter.module.css";

export const HeaderAdvancedFilter = ({ clmName, advancedSearchParams, setAdvancedSearchParams }) => {
	return (
		<div className={styles.container}>
			<SearchSettings
				columnName={clmName}
				value={advancedSearchParams}
				setValue={setAdvancedSearchParams}
				openPopoverIcon={<FilterList sx={{ fontSize: "16px" }} />}
			/>
		</div>
	);
};
